import { getPolicyFromApi, getCookiesPolicyFromApi, postUserConsentFromApi } from "./policy.services";

export const getPolicy = async (type: string) => {
  try {
    const response: any = await getPolicyFromApi(type);
    return response?.data;
  } catch (error: unknown) {
    return error;
  }
};

export const getCookiesPolicy = async (lang: string) => {
  try {
    const response: any = await getCookiesPolicyFromApi(lang);
    return response?.data;
  } catch (error: unknown) {
    return error;
  }
};

export const postUserConsent = async (data: any) => {
  try {
    const response: any = await postUserConsentFromApi(data);
    return response?.data;
  } catch (error: unknown) {
    throw new Error(`Failed to post user consent: ${error}`);
  }
};
